import { useEffect, useState, useContext } from "react";
import { UserContext } from "../context/UserContext";
import { useParams, Link } from "react-router-dom";
import api from "../api";

function ReplyForm({ message, user }) {
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  if (!user || !message) return null;
  if (user.id === message.senderId) return null;

  const handleSend = async (e) => {
    e.preventDefault();
    setSending(true);
    setError("");
    setSuccess("");
    try {
      await api.post("/messages/send", {
        recipientId: message.senderId,
        subject: "Re: " + (message.subject || "(Kein Betreff)"),
        body
      });
      setSuccess("Antwort wurde gesendet.");
      setBody("");
    } catch (e) {
      setError(e?.response?.data?.error || "Fehler beim Senden der Antwort");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={handleSend} style={{ marginTop: 24 }}>
      <h3 style={{ marginBottom: 12 }}>Direkt antworten</h3>
      <textarea
        value={body}
        onChange={e => setBody(e.target.value)}
        rows={4}
        style={{ width: '100%', borderRadius: 8, border: '1px solid #555', padding: 12, background: '#181818', color: '#fff', marginBottom: 12 }}
        placeholder="Antwort eingeben..."
        required
      />
      <button type="submit" disabled={sending || !body.trim()} style={{ background: '#32CD89', color: '#fff', padding: '8px 18px', borderRadius: 8, fontWeight: 600, border: 'none', cursor: 'pointer' }}>
        {sending ? "Senden..." : "Antwort senden"}
      </button>
      {success && <div style={{ color: '#32CD89', marginTop: 12 }}>{success}</div>}
      {error && <div style={{ color: '#c00', marginTop: 12 }}>{error}</div>}
    </form>
  );
}

export default function MessagesDetail() {
  const { id } = useParams();
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { user } = useContext(UserContext);

  useEffect(() => {
    setLoading(true);
    api.get(`/messages/${id}`)
      .then(res => {
        setMessage(res.data);
        if (res.data && !res.data.read && user && res.data.recipientId === user.id) {
          api.patch(`/messages/${id}/read`).then(() => {
            api.get(`/messages/${id}`).then(r => setMessage(r.data)).catch(() => {});
          }).catch(() => {});
        }
      })
      .catch(e => setError(e?.response?.data?.error || "Fehler beim Laden der Nachricht"))
      .finally(() => setLoading(false));
  }, [id, user]);

  if (loading) return <div style={{ color: '#fff', textAlign: 'center', marginTop: 40 }}>Nachricht wird geladen...</div>;
  if (error) return <div style={{ color: '#c00', textAlign: 'center', marginTop: 40 }}>{error}</div>;
  if (!message) return <div style={{ color: '#888', textAlign: 'center', marginTop: 40 }}>Nachricht nicht gefunden.</div>;

  return (
    <div style={{ width: '100vw', margin: 0, padding: 0 }}>
      <div style={{ maxWidth: 600, margin: "40px auto", padding: 24, background: "#222", borderRadius: 12, color: "#fff" }}>
        <h2 style={{ textAlign: "center", marginBottom: 18 }}>Nachricht-Details</h2>
        <div style={{ marginBottom: 12 }}>
          <b>Betreff:</b> {message.subject || <span style={{ opacity: 0.7 }}>(Kein Betreff)</span>}
        </div>
        <div style={{ marginBottom: 12 }}>
          <b>Von:</b> {message.senderDisplayName || message.senderUsername || message.senderId} &nbsp; <b>An:</b> {message.recipientDisplayName || message.recipientUsername || message.recipientId}
        </div>
        <div style={{ marginBottom: 12 }}>
          <b>Datum:</b> {new Date(message.sentAt).toLocaleString()}
        </div>
        <div style={{ marginBottom: 18 }}>
          <b>Nachricht:</b>
          <div style={{ marginTop: 8, whiteSpace: 'pre-wrap', background: '#333', borderRadius: 8, padding: '12px 16px' }}>{message.body}</div>
        </div>
        <Link to="/messages" style={{ background: '#32CD89', color: '#fff', padding: '8px 18px', borderRadius: 8, fontWeight: 600, textDecoration: 'none' }}>Zurück zur Inbox</Link>
        <hr style={{ margin: '32px 0', borderColor: '#444' }} />
        <ReplyForm message={message} user={user} />
      </div>
    </div>
  );
}